import type { ApiResponse } from '@evi/shared';
import { api } from './api';

/**
 * A site host's Stripe onboarding invite (Warren, 29 October 2026, The Novelle): the Api's two public routes
 * (apps/api routes/public/siteHostOnboarding.ts). The token goes in the body, never a URL the Api logs.
 */
export interface SiteHostOnboardingView { location_name: string; expires_at: string }
export type SiteHostOnboardingStart = { state: 'open'; url: string } | { state: 'complete' };

export const fetchSiteHostOnboarding = (token: string) => api.post('public/site-host-onboarding/lookup', { json: { token }, retry: 0 })
  .json<ApiResponse<SiteHostOnboardingView>>().then((r) => r.data);
export const startSiteHostOnboarding = (token: string) => api.post('public/site-host-onboarding/start', { json: { token }, retry: 0 })
  .json<ApiResponse<SiteHostOnboardingStart>>().then((r) => r.data);

/** Only a Stripe-hosted onboarding page is ever opened from the invite. */
export const isStripeOnboardingUrl = (url: unknown): url is string => typeof url === 'string' && /^https:\/\/connect\.stripe\.com\//.test(url);
